import { provideRouter, Routes, withRouterConfig } from '@angular/router';
import { SettingsPageComponent } from './shell/settings/settings-page.component';
import { authGuardWithForcedLoginFunction } from './route/auth/auth-guard-with-forced-login.service';
import { LogOutComponent } from './shell/log-out/log-out.component';
import { MainNavigationComponent } from './shell/main-navigation.component';
import { MessagesPageComponent } from './shell/messages/messages-page.component';
import { ErrorPageComponent } from './shell/error-page/error-page.component';
import { authGuard } from './route/auth/auth-guard';
import { AuthFailedComponent } from './shell/auth-failed/auth-failed.component';
import { LoginComponent } from './shell/login/login.component';
import { ProjectPageComponent } from './projects/project/project-page.component';
import { OnlineOrderListViewComponent } from './orders/online-orders/online-order-list-view/online-order-list-view.component';
import { OnlineOrderEditorComponent } from './orders/online-orders/online-order-editor/online-order-editor.component';
import { OnlineOrderViewComponent } from './orders/online-orders/online-order-view/online-order-view.component';
import { OnlineOrderReportViewComponent } from './orders/online-orders/online-order-report-view/online-order-report-view.component';
import { OnlineOrderDetailsViewComponent } from './orders/online-orders/online-order-details-view/online-order-details-view.component';
import { SelectProjectResolver } from './orders/select-project.resolver';
import { OfflineOrderViewComponent } from './orders/offline-orders/offline-order-view/offline-order-view.component';
import { OfflineOrderEditorComponent } from './orders/offline-orders/offline-order-editor/offline-order-editor.component';
import { OrderResolver } from './orders/order.resolver';
import { ManualPageComponent } from './shell/manual/manual-page.component';
import { canDeactivateGuard } from './shared/component-based-candeactivate.guard';
import { TranslatedTitleResolver } from './route/translated-title.resolver';

/* Attention: route names are used as ids for translation
 *            see assets/i18n => de.json/en.json
 */

export const routeProjects = 'projects';
export const routeOrders = 'orders';
export const routeOfflineOrders = 'offlineOrders';
export const routeForms = 'forms';
export const routeSearch = 'search';
export const routeSettings = 'settings';
export const routeMessages = 'messages';
export const routeLogoff = 'logoff';
export const routeLogin = 'login';
export const routeError = 'error';
export const routeAuthFailed = 'auth-failed';
export const routeNoProjectsAvailable = 'noproject';
export const routeManual = 'manual';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuardWithForcedLoginFunction],
    component: MainNavigationComponent,

    children: [
      {
        path: '',
        redirectTo: routeProjects,
        pathMatch: 'full'
      },
      {
        path: routeProjects,
        component: ProjectPageComponent,
        title: TranslatedTitleResolver,
        data: {
          titleKey: 'COMMANDS.PROJECTS'
        }
      },
      {
        path: `${routeOrders}/:project`,
        component: OnlineOrderListViewComponent,
        title: TranslatedTitleResolver,
        data: {
          titleKey: 'COMMANDS.ORDERS'
        }
      },
      {
        path: `${routeOfflineOrders}`,
        component: OfflineOrderViewComponent,
        title: TranslatedTitleResolver,
        data: {
          titleKey: 'COMMANDS.OFFLINEORDERS'
        }
      },
      {
        path: `${routeOfflineOrders}/:id`,
        component: OfflineOrderEditorComponent
      },
      {
        path: `${routeOrders}/:project/edit/:form`,
        component: OnlineOrderEditorComponent,
        canDeactivate: [canDeactivateGuard],
        resolve: { document: SelectProjectResolver }
      },
      {
        path: `${routeOrders}/:project/view/:form`,
        component: OnlineOrderViewComponent,
        resolve: { document: SelectProjectResolver }
      },
      {
        path: `${routeOrders}/:project/detail/:order`,
        component: OnlineOrderDetailsViewComponent,
        resolve: { order: OrderResolver }
      },
      {
        path: `${routeOrders}/:project/report/:order`,
        component: OnlineOrderReportViewComponent,
        resolve: { document: SelectProjectResolver }
      },
      {
        path: routeSettings,
        component: SettingsPageComponent,
        canActivate: [authGuard],
        title: TranslatedTitleResolver,
        data: {
          titleKey: 'COMMANDS.SETTINGS'
        }
      },
      {
        path: routeMessages,
        component: MessagesPageComponent,
        canActivate: [authGuard],
        title: TranslatedTitleResolver
      },
      {
        path: routeManual,
        component: ManualPageComponent,
        title: TranslatedTitleResolver,
        data: {
          titleKey: 'COMMANDS.MANUAL'
        }
      }
      /*
      {
        path: routeLogoff,
        component: SettingsPageComponent,
        pathMatch: 'full',
        canActivate: [AuthGuard],
      },
       */
    ]
  },
  { path: routeLogin, component: LoginComponent },
  { path: routeLogoff, component: LogOutComponent, pathMatch: 'full' },
  { path: routeError, component: ErrorPageComponent },
  { path: routeAuthFailed, component: AuthFailedComponent },
  { path: '**', redirectTo: '/' }
];

export function provideLiveFormsRouting() {
  return provideRouter(
    routes,
    //withDebugTracing(),
    withRouterConfig({
      canceledNavigationResolution: 'computed'
    })
  );
}
